window.addEventListener("load", ()=> {
  // fix for missing image thumbnails on product page
  function findTheVariant(data) {
    return data = data.toLowerCase().replace(" ", "").split("|")[0].split(":")[1].trim();
  }
  function activateThumbnails() {
    let activeVariantValue = document.querySelector(".main-product__media-gallery__inner-media--image[active] img");
    if (activeVariantValue) {
      activeVariantValue = findTheVariant(activeVariantValue.getAttribute("alt"));      
      const thumbnails =  document.querySelectorAll("custom-product-thumbnails .main-product-media__thumbnails li");
      
      thumbnails.forEach(item => {
        const thumbnailVariant = findTheVariant(item.getAttribute("data-media-alt"));
        
        if (thumbnailVariant === activeVariantValue) {
          item.removeAttribute("hidden", "");
          item.classList.remove("hidden");
        }
        else {
          item.classList.add("hidden");
          item.setAttribute("hidden", "");
        }
      });
    }
  }

  function selectFirstThumbnail() {
    const visibleThumbnails = document.querySelectorAll(".main-product-media__thumbnails > li:not([hidden])");
    const button = visibleThumbnails[0].querySelector("button[aria-current]");
    if (button) {
      button.click();
    }
  }
  const multiSelector = document.querySelector("multi-selector");

  if (!multiSelector) {
    activateThumbnails();
  }
  else {
    selectFirstThumbnail();
  }
  
  const mediaGallery = document.querySelector(".main-product__media-gallery__inner");
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        if (!multiSelector) {
          activateThumbnails();
        }
        else {
          selectFirstThumbnail();
          observer.disconnect();
          observer.observe(mediaGallery, config);
        }
      }
    }
  };
  
  const observer = new MutationObserver(callback);
  observer.observe(mediaGallery, config);
});